import xhr from 'live/services/xhr'

export function getEntitiesByTimestamp(data: EntitiesByTimestamp): Promise<any> {
    return xhr
        .post('/services/plugin-static-data-manager/query/getEntitiesByTimestamp', data)
        .then(response => response?.data)
}

export function getEntitiesByTimestampAndAssetId(data: EntitiesByTimestamp): Promise<any> {
    return xhr
        .post('/services/plugin-static-data-manager/query/getEntitiesByTimestampAndRigAssetId', data)
        .then(response => response?.data)
}
